import {CustomEvalResult} from 'notebook/tables/constants/CustomEvalConstants';
import * as ExcessUtil from 'notebook/tables/excess/Util';
import {coerceToPrimitiveNumber, isTypedValueEmpty} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

/** A DAR of 0 is an unconjugated antibody, which is not registered as an ADC. */
export const MIN_TARGET_DAR = 1;
/** Clinical ADCs typically target a DAR of 2-8, and high-DAR platforms reach the mid-teens. */
export const MAX_TARGET_DAR = 20;

export const TARGET_DAR_RANGE_ERROR = `Target DAR must be between ${MIN_TARGET_DAR} and ${MAX_TARGET_DAR}.`;

/**
 * Custom eval for the ADC Target DAR column, which rejects numbers outside
 * [MIN_TARGET_DAR, MAX_TARGET_DAR]. Empty, non-numeric, and fractional values pass through unchanged; the
 * column's integer resolution reports those.
 */
export function adcTargetDarColumnCustomEval(typedValue: TypedValue): CustomEvalResult {
  const targetDar = isTypedValueEmpty(typedValue) ? null : coerceToPrimitiveNumber(typedValue);
  if (targetDar != null && (targetDar < MIN_TARGET_DAR || targetDar > MAX_TARGET_DAR)) {
    return {val: typedValue, error: new ExcessUtil.ValueError(TARGET_DAR_RANGE_ERROR), locked: false};
  }
  return {val: typedValue, error: null, locked: false};
}
